"use strict";

import { combineEpics } from "redux-observable";

import {
    homeGetRealTimeRewardCodeEpic,
    homeGetRealTimeRewardReasonListEpic,
    homeGetParticipantListEpic,
    homeSmsRealTimeRewardCodeEpic,
    homeCampaignListEpic,
    homeGetRealTimeRewardCampaignEpic,
    homeGetChatBotReplyQuestionEpic,
    homeGetChatbotFaqQuestionsEpic,
    getParticipantJobRoleEpic,
    getLcvAssignableJobRolesEpic,
    getDealerParticipantListEpic,
    registerDealerParticipantEpic,
    registerLcvTeamMemberEpic,
    removeLcvTeamMemberEpic,
    updateLcvTeamMemberStatusEpic,
    requestActivateAccountEpic,
    updateDealerParticipantStatusEpic,
    removeDealerParticipantEpic,
    homeUserLoginStatusEpic,
    getTeamGamePlayDetailsEpic,
    getDealerLiquidGoldScratchCodesEpic,
    getLcvTeamGameCodesEpic,
    assignParticipantLiquidGoldScratchCodeEpic,
    lcvGameCodeAllocationEpic,
    lcvGameCodeResetEpic,
    removeParticipantLiquidGoldScratchCodeEpic,
    homeSendGamePlayCodeEpic,
    homeResetGamePlayCodeEpic,
    homeGetNotificationEpic,
    homeDeleteNotificationEpic,
    homeGetNotificationCountEpic,
    homeGetPopupStatusEpic,
    homeTurnOffPopupEpic,
} from "./home.epics";

import {
    getKnowlegeLatestQuizzesEpic,
    getKnowlegeDasboardEpic,
    getKnowlegeParticipantQuizzesEpic,
    getKnowlegeQuizzDetailsEpic,
    knowlegeAnswerQuestionEpic,
    knowlegeEnrolQuizzEpic,
    knowlegeQuestioResultEpic,
} from "./knowledge.epics";

import {
    getShopFavouritesEpic,
    getShopTopPicksEpic,
    getShopTrendingsEpic,
    getShopVoucherDetailsEpic,
    getShopVoucherWalletEpic,
    getShopOrderDetailsEpic,
    shopConfirmOrderEpic,
    getShopBrowserProductsEpic,
    getShopPopularFilterEpic,
    getShopCategoryEpic,
    shopBuyPointsEpic,
    setVoucherRedeemStatusEpic,
    shopRateVoucherEpic,
    shopTLCGetPointBalanceEpic,
    shopTLCRebatePointsEpic,
} from "./shop.epic";

import {
    loginAuthEpic,
    logoutAuthEpic,
    authUserProfileDetailsEpic,
    getNewActionTokenEpic,
    reRegistrationEpic,
    preRegistrationActivateEpic,
    forgotPasswordEmailVeryficationEpic,
    forgotPasswordResetPasswordEpic,
    sendOptEpic,
    reSendOptEpic,
    changePasswordEpic,
    changeMobileNumberEpic,
    sendOTPAfterLoginEpic,
    profilePictureUploadEpic,
    profileNotificationChangeEpic,
    profileChangeHomeAddressEpic,
    changeProfileNameEpic,
    getUserDetailsEpic,
    getParticipantProfileEpic,
    subscribeEpic,
    userDeviceEpic,
    validateParticipantByEmailEpic,
} from "./auth.epics";

import {
    getUserAchievementsEpic,
    getUserThingsToDoEpic,
    getUserMembershipEpic,
    getUserPointsTransactionsEpic,
    getUserGoalsEpic,
    getUserIncentiveHistoryEpic,
    getParticipantNotificationEpic,
    getNewsFeedEpic,
    readNotificationEpic,
    getUserPointsBalanceEpic,
    getLatestTransactionEpic,
    userAccountLogUserLogStatusEpic,
} from "./user.epics";

import {
    getLatestCampaignEpic,
    getHomeCarouselCampaignEpic,
    getHomeGetBestVoucherDealsTodayEpic,
    getHomeGetTrendingVouchersEpic,
    getFeaturedCampaignBannersEpic,
    getHomeGetCampaignDetailsEpic,
    campaignTokenValidationEpic,
    campaignValidateLiquidGoldScratchCodeEpic,
    campaignSpinwingetDataEpic,
    campaignSpinwingetInitialDataEpic,
    joinIncentiveDataEpic,
    getCampaignHomeBannersEpic,
    getCampaignVoucherAddToFavouriteEpic,
    getCampaignVoucherRemoveFromFavouriteEpic,
    getCampaignLeagueTableEpic,
    getParticipantSalesEpic,
    campaignPrizeDrawDetailsEpic,
    addPrizeDrawCampaignEntryDataEpic,
    getLeagueTeamDetailsEpic,
    getLeagueIndividualDetailsEpic,
    submitLeagueTeamParticipantEpic,
    getCommsDetailsEpic,
    campaignGetWareAndTireSummaryEpic,
    campaignGetLeagueTableSummaryEpic,
    campaignGetParticipantIncentiveEpic,
    campaignGetParticipantIncentiveCampaignPerformanceMetricsEpic,
    campaignGetCastrolLeagueTableSummaryEpic,
    campaignPageLogPageViewEpic,
    campaignLikeContentPageEpic,
    campaignLikeSummaryEpic,
    campaignGetAreaManagerDealersEpic,
    campaignGetOverdriveDealersEpic,
    campaignGetParticipantsByDealerEpic,
    campaignGetPerformanceMetricsByDealerEpic,
    campaignGetAreaManagersLeaguesRankSummaryEpic,
    campaignGetCastrolLeagueQ4TableSummaryEpic,
    campaignGetServiceManagersLeaguesBonusBrakePadsRankSummaryEpic,
    campaignGetServiceManagersLeaguesBonusRankWiperBladeSummaryEpic,
    campaignGetServiceManagersLeaguesBonusRankBrakeDiscsSummaryEpic,
    campaignGetServiceManagersLeaguesBonusRankAreaTopPerformerSummaryEpic,
    campaignGetServiceManagersLeaguesBonusBatteryRankSummaryEpic,
    campaignGetLeagueNationalTopPerformerSummaryEpic,
    getTlcCustomerEpic,
    getGoldRushCampaignPerformanceSummaryEpic,
    getCastrolDealerPerformanceSummaryEpic,
    campaignGetPerformanceMetricsByDealerDropDownEpic,
    campaignGetServiceManagersLeaguesBonusBatteryRankSummaryDropDownEpic,
    campaignGetLeagueNationalTopPerformerSummaryDropDownEpic,
    campaignGetLeagueTableSummaryDropDownEpic,
    campaignGetTlcRetailersEpic,
    campaignGetWearAndTearTeamPerformanceSummaryEpic,
    campaignGetServiceStartLeagueRankSummaryEpic,
    campaignGetWinningSpinDataEpic,
    campaignGetLcvRegistrationTrackerEpic,
    campaignGetLcvWinningSpinsEpic,
    campaignGetAlpineRewardSummaryEpic,
    campaignGetTradePartsManagerSalesSummaryEpic,
    campaignGetCastrolMotoLeaguesRankSummaryEpic,
    campaignGetTLCCustomerByDealersEpic,
    campaignGetFullThrottleLeagueRankSummaryEpic,
    campaignGoldenTicketScratchCardDataEpic,
    campaignGoldenTicketClaimScratchCardCodeEpic,
    campaignVoteRewardPreferencesEpic,
    campaignGetAllAreaManagerDealersEpic,
    campaignGetCastrol500CampaignDataEpic,
    campaignGetEarnBigBrakeCampaignDataEpic,
    campaignGetCuttingEdgeQ3CampaignDataEpic,
    campaignGetCuttingEdgeQ4CampaignDataEpic,
    campaignGetFullThrottleLeagueRankQ3SummaryEpic,
    campaignGetDealerEhcvFocusCampaignDataEpic,
    campaignGetServiceStar2026CampaignDataEpic,
    campaignGetIcrmCampaignDataEpic,
    campaignGetCuttingEdgeCampaignDataEpic,
    campaignSearchCustomersEpic,
    campaignGetMotrioTradeTargetsEpic,
    campaignGetCustomerAccountStatusEpic,
    campaignGetRgRewardsTargetsEpic,
    campaignGetRgRewardsTargetsByCustomerEpic,
    campaignSendActivationEmailEpic,
    campaignGetMotrioRewardsByCustomerEpic,
    campaignGetMotrioPaydaysWinnersEpic,
    campaignGetCastrolLegendsCampaignDataEpic,
    campaignGetCastrolLegendsCampaignPerformanceDataEpic,
    campaignGetLiquidGoldCampaignInfoEpic,
    campaignClaimLiquidGoldScratchCodeEpic,
    campaignGetOptimumFrictionCampaignInfoEpic,
    campaignGetOptimumFrictionCardsEpic,
    campaignGetOptimumFrictionWinnersEpic,
    campaignPlayOptimumFrictionCardEpic,
    campaignGetOverDriveCampaignDataEpic,
} from "./campiagn.epics";
import { imageUploadCommonEpic } from "./common.epic";

import {
    insightLiveboardEpic,
    insightParticipantJobRoleAndCountEpic,
    insightDealersSummaryStatEpic,
    sherbotAIInstructionsEpic,
    sherbotAIInstructionUpdateEpic,
} from "./insights.epic";

export default combineEpics(
    loginAuthEpic,
    logoutAuthEpic,
    getNewActionTokenEpic,
    reRegistrationEpic,
    preRegistrationActivateEpic,
    forgotPasswordEmailVeryficationEpic,
    forgotPasswordResetPasswordEpic,
    sendOptEpic,
    reSendOptEpic,
    changePasswordEpic,
    sendOTPAfterLoginEpic,
    changeMobileNumberEpic,
    profilePictureUploadEpic,
    profileNotificationChangeEpic,
    profileChangeHomeAddressEpic,
    changeProfileNameEpic,
    getUserDetailsEpic,
    getParticipantProfileEpic,
    subscribeEpic,
    userDeviceEpic,
    validateParticipantByEmailEpic,
    homeUserLoginStatusEpic,
    userAccountLogUserLogStatusEpic,

    authUserProfileDetailsEpic,
    getLatestCampaignEpic,
    getFeaturedCampaignBannersEpic,
    getHomeGetCampaignDetailsEpic,
    campaignTokenValidationEpic,
    campaignValidateLiquidGoldScratchCodeEpic,
    campaignSpinwingetDataEpic,
    campaignSpinwingetInitialDataEpic,
    joinIncentiveDataEpic,
    getCampaignHomeBannersEpic,
    getCampaignVoucherAddToFavouriteEpic,
    getCampaignVoucherRemoveFromFavouriteEpic,
    getCampaignLeagueTableEpic,
    getParticipantSalesEpic,
    campaignPrizeDrawDetailsEpic,
    addPrizeDrawCampaignEntryDataEpic,
    getLeagueTeamDetailsEpic,
    getLeagueIndividualDetailsEpic,
    submitLeagueTeamParticipantEpic,
    getCommsDetailsEpic,
    campaignGetWareAndTireSummaryEpic,
    campaignGetLeagueTableSummaryEpic,
    campaignGetParticipantIncentiveEpic,
    campaignGetParticipantIncentiveCampaignPerformanceMetricsEpic,
    campaignGetCastrolLeagueTableSummaryEpic,
    campaignPageLogPageViewEpic,
    campaignLikeContentPageEpic,
    campaignLikeSummaryEpic,
    campaignGetAreaManagerDealersEpic,
    campaignGetOverdriveDealersEpic,
    campaignGetParticipantsByDealerEpic,
    campaignGetPerformanceMetricsByDealerEpic,
    campaignGetAreaManagersLeaguesRankSummaryEpic,
    campaignGetCastrolLeagueQ4TableSummaryEpic,
    campaignGetServiceManagersLeaguesBonusBrakePadsRankSummaryEpic,
    campaignGetServiceManagersLeaguesBonusRankWiperBladeSummaryEpic,
    campaignGetServiceManagersLeaguesBonusRankBrakeDiscsSummaryEpic,
    campaignGetServiceManagersLeaguesBonusRankAreaTopPerformerSummaryEpic,
    campaignGetServiceManagersLeaguesBonusBatteryRankSummaryEpic,
    campaignGetLeagueNationalTopPerformerSummaryEpic,
    campaignGetPerformanceMetricsByDealerDropDownEpic,
    campaignGetServiceManagersLeaguesBonusBatteryRankSummaryDropDownEpic,
    campaignGetLeagueNationalTopPerformerSummaryDropDownEpic,
    getTlcCustomerEpic,
    getGoldRushCampaignPerformanceSummaryEpic,
    getCastrolDealerPerformanceSummaryEpic,
    campaignGetLeagueTableSummaryDropDownEpic,
    campaignGetTlcRetailersEpic,
    campaignGetWearAndTearTeamPerformanceSummaryEpic,
    campaignGetServiceStartLeagueRankSummaryEpic,
    campaignGetWinningSpinDataEpic,
    campaignGetLcvRegistrationTrackerEpic,
    campaignGetLcvWinningSpinsEpic,
    campaignGetAlpineRewardSummaryEpic,
    campaignGetTradePartsManagerSalesSummaryEpic,
    campaignGetCastrolMotoLeaguesRankSummaryEpic,
    campaignGetTLCCustomerByDealersEpic,
    campaignGetFullThrottleLeagueRankSummaryEpic,
    campaignGoldenTicketScratchCardDataEpic,
    campaignGoldenTicketClaimScratchCardCodeEpic,
    campaignVoteRewardPreferencesEpic,
    campaignGetAllAreaManagerDealersEpic,
    campaignGetCastrol500CampaignDataEpic,
    campaignGetEarnBigBrakeCampaignDataEpic,
    campaignGetCuttingEdgeQ3CampaignDataEpic,
    campaignGetCuttingEdgeQ4CampaignDataEpic,
    campaignGetFullThrottleLeagueRankQ3SummaryEpic,
    campaignGetDealerEhcvFocusCampaignDataEpic,
    campaignGetServiceStar2026CampaignDataEpic,
    campaignGetIcrmCampaignDataEpic,
    campaignGetCuttingEdgeCampaignDataEpic,
    campaignSearchCustomersEpic,
    campaignGetMotrioTradeTargetsEpic,
    campaignGetCustomerAccountStatusEpic,
    campaignGetRgRewardsTargetsEpic,
    campaignGetRgRewardsTargetsByCustomerEpic,

    getUserAchievementsEpic,
    getUserThingsToDoEpic,
    getUserMembershipEpic,
    getUserPointsTransactionsEpic,
    getUserGoalsEpic,
    getUserIncentiveHistoryEpic,
    getParticipantNotificationEpic,
    getNewsFeedEpic,
    readNotificationEpic,
    getUserPointsBalanceEpic,
    getLatestTransactionEpic,

    getHomeCarouselCampaignEpic,
    getHomeGetBestVoucherDealsTodayEpic,
    getHomeGetTrendingVouchersEpic,

    getShopFavouritesEpic,
    getShopTopPicksEpic,
    getShopTrendingsEpic,
    getShopVoucherDetailsEpic,
    getShopVoucherWalletEpic,
    getShopOrderDetailsEpic,
    shopConfirmOrderEpic,
    getShopBrowserProductsEpic,
    getShopPopularFilterEpic,
    getShopCategoryEpic,
    shopBuyPointsEpic,
    setVoucherRedeemStatusEpic,
    shopRateVoucherEpic,
    shopTLCGetPointBalanceEpic,
    shopTLCRebatePointsEpic,

    getKnowlegeLatestQuizzesEpic,
    getKnowlegeDasboardEpic,
    getKnowlegeParticipantQuizzesEpic,
    getKnowlegeQuizzDetailsEpic,
    knowlegeAnswerQuestionEpic,
    knowlegeEnrolQuizzEpic,
    knowlegeQuestioResultEpic,

    homeGetRealTimeRewardCodeEpic,
    homeGetRealTimeRewardReasonListEpic,
    homeGetParticipantListEpic,
    homeSmsRealTimeRewardCodeEpic,
    homeCampaignListEpic,
    homeGetRealTimeRewardCampaignEpic,
    getTeamGamePlayDetailsEpic,
    getDealerLiquidGoldScratchCodesEpic,
    getLcvTeamGameCodesEpic,
    assignParticipantLiquidGoldScratchCodeEpic,
    lcvGameCodeAllocationEpic,
    lcvGameCodeResetEpic,
    removeParticipantLiquidGoldScratchCodeEpic,
    homeSendGamePlayCodeEpic,
    homeResetGamePlayCodeEpic,
    homeGetNotificationEpic,
    homeDeleteNotificationEpic,
    homeGetNotificationCountEpic,
    homeGetPopupStatusEpic,
    homeTurnOffPopupEpic,

    imageUploadCommonEpic,
    homeGetChatBotReplyQuestionEpic,
    homeGetChatbotFaqQuestionsEpic,
    getParticipantJobRoleEpic,
    getLcvAssignableJobRolesEpic,
    getDealerParticipantListEpic,
    registerDealerParticipantEpic,
    registerLcvTeamMemberEpic,
    removeLcvTeamMemberEpic,
    updateLcvTeamMemberStatusEpic,

    updateDealerParticipantStatusEpic,
    removeDealerParticipantEpic,
    requestActivateAccountEpic,

    insightLiveboardEpic,
    campaignSendActivationEmailEpic,
    insightParticipantJobRoleAndCountEpic,
    insightDealersSummaryStatEpic,
    campaignGetMotrioRewardsByCustomerEpic,
    campaignGetMotrioPaydaysWinnersEpic,
    campaignGetCastrolLegendsCampaignDataEpic,
    campaignGetCastrolLegendsCampaignPerformanceDataEpic,
    campaignGetLiquidGoldCampaignInfoEpic,
    campaignClaimLiquidGoldScratchCodeEpic,
    campaignGetOptimumFrictionCampaignInfoEpic,
    campaignGetOptimumFrictionCardsEpic,
    campaignGetOptimumFrictionWinnersEpic,
    campaignPlayOptimumFrictionCardEpic,
    campaignGetOverDriveCampaignDataEpic,

    sherbotAIInstructionsEpic,
    sherbotAIInstructionUpdateEpic,
);
